import { FC, memo } from 'react';
import { actionIconMap } from './constants';
import { actionButtonStyles } from './alert.styles';
import { AlertProps } from './types';
import { twMerge } from 'tailwind-merge';

type AlertActionButtonProps = Pick<AlertProps, 'type' | 'actionButtonText' | 'onAction'>;

const AlertActionButtonComp: FC<AlertActionButtonProps> = ({ type, actionButtonText, onAction }) => {
  return (
    <button type='button' onClick={onAction} className={twMerge('w-fit flex items-center gap-2 pt-2', actionButtonStyles({ type }))}>
      {actionIconMap[type] ?? null}
      {actionButtonText}
    </button>
  );
};

export const AlertActionButton = memo(AlertActionButtonComp);
